import { HeaderMenuDropdown } from '../styles'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

import { useEffect, useState } from 'react'
import { useAppDispatch } from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { setSearchParam } from 'srs.sharedcomponents/lib/esm/redux/slices/productlistSlice'

interface HeadersProps {
  headers?: any[]
  isLoading?: boolean
  onMenuClick?: (item: any, event: React.MouseEvent) => void
  getLinkProps?: (item: any) => any
}

const MenuHeaders = ({
  headers = [],
  isLoading: loadingProp,
  onMenuClick,
  getLinkProps,
}: HeadersProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(loadingProp ?? false)
  const dispatch = useAppDispatch()
  useEffect(() => {
    setIsLoading(loadingProp ?? false)
  }, [loadingProp])

  return (
    <>
      {isLoading ? (
        <div>
          <Stack spacing={1} style={{ width: '300px', gap: '0px' }}>
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
          </Stack>
        </div>
      ) : (
        <>
          {[...(headers || [])].map((item) => {
            const linkProps = getLinkProps
              ? getLinkProps(item)
              : { to: item.url, external: false }
            return (
              <HeaderMenuDropdown
                className="productsHeaderList"
                key={item.id || item.name}
                href={linkProps.to || '#'}
                target={
                  linkProps.external ? linkProps.target || '_blank' : undefined
                }
                rel={linkProps.external ? 'noopener noreferrer' : undefined}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  if (onMenuClick) {
                    onMenuClick(item, e)
                    dispatch(setSearchParam(''))
                  }
                }}
              >
                {item.name}
              </HeaderMenuDropdown>
            )
          })}
        </>
      )}
    </>
  )
}

export { MenuHeaders }
